import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './providers';
import { Toaster } from '@/components/feedback';
import { router } from './router';

export default function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
      <Toaster />
    </AppProviders>
  );
}
